import ProjectItemSkeleton from './ProjectItem/ProjectItemSkeleton';
import './WorkProjectsListSkeleton.scss';

const WorkProjectsListSkeleton = () => {
    const positions = ['right', 'left', 'right', 'left', 'right'];

    return (
        <div className="work-projects-skeleton">
            {positions.map((position, index) => (
                <ProjectItemSkeleton key={index} position={position} />
            ))}
        </div>
    );
};

export default WorkProjectsListSkeleton;